import { ReceivablePaymentLetter } from '../models/Entities';
import { adminApiAxios } from './CustomAxios';

class ReceivablePaymentLetterApi {
    create = async (receivablePaymentLetter: ReceivablePaymentLetter): Promise<Blob> => {
        const response = await adminApiAxios.post<Blob>(`/receivable-payment-letters`, receivablePaymentLetter, {
            responseType: 'blob'
        });

        return response.data;
    };
}

const receivablePaymentLetterApi: ReceivablePaymentLetterApi = new ReceivablePaymentLetterApi();
export default receivablePaymentLetterApi;
